import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpUtilsService } from 'app/core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from 'app/core/_base/crud';
import { KhieuNaiKhachHangModel,FileAttachmentModel } from '../khieu-nai-khach-hang-model/khieu-nai-khach-hang.model';
const API_ROOT_URL = environment.ApiRoot + '/khieunaikhachhang';
@Injectable()
export class KhieuNaiKhachHangService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }
	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
			const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
			return this.http.get<any>(API_ROOT_URL + '/KhieuNaiKhachHang_List', { 
				headers: httpHeaders,
				params: httpParams
			});
	}
	getKhieuNaiKhachHangById(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/KhieuNaiKhachHang_Detail?Id=${itemId}`,{ headers: httpHeaders });
	}
	deleteKhieuNaiKhachHang(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/KhieuNaiKhachHang_Delete?Id=${itemId}`;
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	deleteKhieuNaiKhachHangs(ids: any[] = []): Observable<any> {
		const url = API_ROOT_URL + '/deleteSelect';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<QueryResultsModel>(url, ids, { headers: httpHeaders} );
	}
	createKhieuNaiKhachHang(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<KhieuNaiKhachHangModel>(API_ROOT_URL+'/KhieuNaiKhachHang_Insert', item, { headers: httpHeaders });
	}
	updateKhieuNaiKhachHang(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<KhieuNaiKhachHangModel>(API_ROOT_URL+'/KhieuNaiKhachHang_Update', item, { headers: httpHeaders });
	}
    //#region ***filter***
    getFilterGroup(column: string, url: string): Observable < any > {
        return this.http.get<any>(environment.ApiRoot + url + `${column}`);
    }
	uploadFileKhieuNaiKhachHang(data): Observable<any> {
		const url = API_ROOT_URL + '/DM_LoaiThanhPham_UploadFile';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders });
	}
	importKhieuNaiKhachHang(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<KhieuNaiKhachHangModel>(API_ROOT_URL+'/DM_LoaiThanhPham_Import', item, { headers: httpHeaders });
	}
	downloadTemplate(): string {
		return API_ROOT_URL + `/DownLoadFileImportMau`;
	}

	Xuatfile(item:FileAttachmentModel){
		// var data = new FormData();
		
		// var item_data : any={};
		// item_data.urlfile =item.urlfile;
		// let params = `url=${item.urlfile}&filename=${item.filename}`;
		// var json = JSON.stringify(item);
		
		var request = new XMLHttpRequest();
		var link = API_ROOT_URL + `/DownLoadFileAttachment?url=${item.urlfile}&filename=${item.filename}`;
		request.open('GET', link);
		// request.setRequestHeader("Token", this.auth.getStringTokenOfUser());
		request.responseType = 'arraybuffer';
		var _this=this;
		request.onload = function (e) {
			
			var name = item.filename;
			var file = new Blob([this.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			if (navigator.msSaveBlob) {
				return navigator.msSaveBlob(file);
			}
			
			var a = document.createElement("a");

			var url = window.URL.createObjectURL(file);
			a.setAttribute("href", url);
			a.setAttribute("download", name);

			a.click();

			window.URL.revokeObjectURL(url);
			
		};
		request.send();
	}
}
